'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var constate = require('constate');
var contexts_DataTableContext = require('./contexts/DataTableContext.js');
require('@babel/runtime/helpers/defineProperty');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var Provider = function Provider(_ref) {
  var children = _ref.children,
      theme = _ref.theme,
      type = _ref.type;
  var initialState = React__default["default"].useMemo(function () {
    return {
      app: {
        type: type
      }
    };
  }, [type]);
  return (
    /*#__PURE__*/
    // @ts-expect-error TS(2322): Type '{ children: Element; initialState: { app: { ... Remove this comment to see the full error message
    React__default["default"].createElement(constate.Provider, {
      initialState: initialState,
      theme: theme
    }, /*#__PURE__*/React__default["default"].createElement(contexts_DataTableContext.Provider, null, children))
  );
};
Provider.defaultProps = {
  theme: undefined,
  type: undefined
};

Object.defineProperty(exports, 'Container', {
  enumerable: true,
  get: function () { return constate.Container; }
});
exports.Provider = Provider;
